import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";
import type { CalendarsConfig } from "../../Calendars/Models/Domain";
import type { CalendarsConfigApi } from "../../Calendars/Models/Api";

import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";
import CalendarEventReminderTransformer from "./EventReminder";

import { hasValue } from "@/Utils/Objects";

const CalendarsConfigTransformer: TransformerExtended<CalendarsConfig, CalendarsConfigApi> = {
  ...DefaultTransformerGenerator<CalendarsConfig, CalendarsConfigApi>(),

  toDomain(input: CalendarsConfigApi): CalendarsConfig {
    return {
      cancellationPolicyTime: input.cancellation_policy_time,
      reminders: hasValue(input.reminders)
        ? input.reminders.map(CalendarEventReminderTransformer.toDomain)
        : [],
    };
  },

  toApi(input: CalendarsConfig): CalendarsConfigApi {
    return {
      cancellation_policy_time: input.cancellationPolicyTime,
      reminders: hasValue(input.reminders) ? input.reminders.map(CalendarEventReminderTransformer.toApi) : [],
    };
  },
};

export type CalendarsConfigTransformerType = TransformerExtended<CalendarsConfig, CalendarsConfigApi>;

export default CalendarsConfigTransformer;
